import styled from "styled-components";

interface IProps {
  isArabic?: boolean;
}

export const HeaderSection = styled("header")`
font-size: 100%;
height:auto;
line-height: 1;
background: #FFF;
font-family: Arial, Helvetica, sans-serif;
border: 0;
margin: 0;
outline: 0;
padding: 0;
//text-align: left;
vertical-align: baseline;
display: block;
border-radius: 4px;
box-sizing: border-box;
box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.8);
`;

export const MainTopUtility = styled("div")`
  background-color: #515358;
 // min-height: 33px;
`;
export const MainTopUtilityRow = styled("div")`
    width: 100%;
    margin: 0 auto;
    z-index: 10;
    position: relative;
    max-width: 940px;
    padding: 0;
    min-height: 33px;
`;

export const MainTopNavigation = styled("div")`
    // position: relative;
    // max-width: 90%;
    // @media screen and (max-width: 600px){
    //   max-width: 100%;
    //   }
    // padding: 0 10px;
    // z-index: 2;
    // transform: translateY(-40%);
    position: relative;
    padding: 0 10px;
    z-index: 2;
    -webkit-transform: translateY(-40%);
    -ms-transform: translateY(-40%);
    transform: translateY(-40%);
    margin: 0 auto;
    z-index: 10;
    max-width: 940px;
`

export const SiteControls =styled.span<IProps>`
  padding: ${(p) => (p.isArabic? "10px 35px 0px 5px;" : "10px 5px 0px 35px" )};
  display: block;
  line-height: 13px;
  cursor: pointer;
  font-size: 100%;
  color: #0a0a0a;
  align-items: center;
  font-weight: bold;
`
export const LangButton = styled.div<IProps>`
float: ${(p) => (p.isArabic? "left" : "right" )};
cursor: pointer;
color:#fff;
font-size: 15px; 
height: 32px; 
position: relative;
font-family: Arial, Helvetica, sans-serif;
// background: rgb(175,10,10);
border: 1px solid #0a0a0a;
// box-shadow: 1px 1px 1px 1px #aaaaaa;
border-radius: 5px;
// background: linear-gradient(0deg, rgba(210,12,12,1), rgba(168,9,9,1), rgba(210,12,12,1));
background:${(p) => (p.isArabic? ("url('/img/svg/language_en.png' ) no-repeat calc(100% - 5px) center;") : ("url('/img/svg/language_ar.png' ) no-repeat 5px center;") )};
box-sizing: border-box;
//transition: all 0.3s ease-in-out;
@media screen and (max-width: 880px){
  Margin: 5px 10px;
  }
&:hover {
  background:${(p) => (p.isArabic? ("url('/img/svg/language_en-red.png' ) no-repeat calc(100% - 5px) center;") : ("url('/img/svg/language_ar-red.png' ) no-repeat 5px center;") )};
}
&:hover ${SiteControls} {
  color:  rgba(210,12,12,1); 
}
&:active,
&:focus {
  border: 1px solid rgb(153, 150, 150);
}
&:disabled{
  opacity: 0.6;
  cursor: not-allowed;
  transition:none;
  &:active,
  &:focus {
    border: none;
  }
  &:hover {
    text-underline-position: none;
    text-decoration: none;
  }
}
    &::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    background-image: url(/img/svg/language_en-red.png), url(/img/svg/language_ar-red.png);
  }
`;

export const LogoContainer = styled.div<IProps>`
float: ${(p) => (p.isArabic? "right" : "left" )};
//${(p) => (p.isArabic ? "@media screen and (max-width: 872px) and (min-width: 631px){padding: 35px 0 0 0}" : "")}
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;
  // @media screen and (max-width: 872){
  //   padding: 10px 0 0 0;
  //   margin: 30px 0;
  //   line-height: 10px;
  //   }
`;

export const ContactWrapper = styled("div")<any>`
  cursor: pointer;
  width: ${(p) => (p.width ? "100%" : "110px")};
  font-weight: 700;
  text-align: center;
  border-radius: 1.25rem;
  display: inline-block;
`;


export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)<IProps>`
  font-size: 1.2rem;
  @media screen and (min-width: 913px) and (max-width: 1280px) {
  font-size: 1.1rem;
  }
    @media screen and (max-width: 913px){
  font-size: 1rem;
  }

  vertical-align: -webkit-baseline-middle;
  ${(p) => (p.isArabic ? "@media screen and (max-width: 880px){display:none}" : "@media screen and (max-width: 880px){display:none}")};

    @media screen and (max-width: 872px){
      padding: 35px 0 0 0;
      }
  color: #000;
  font-weight: bold;
  // margin-bottom:30px;
  transition: color 0.2s ease-in;
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-center;
  align-items: baseline;
`;

export const Span = styled.span<IProps>`
  cursor: pointer;
  vertical-align: -webkit-baseline-middle;
  transition: all 0.3s ease-in-out;
  background: ${(p) => (p.isArabic? `url("./img/svg/section_divider.gif") right center no-repeat;` : `url("./img/svg/section_divider.gif") left center no-repeat;` )};
  padding: 24px 10px 18px;
  &:hover,
  &:active,
  &:focus {
    text-underline-position: under;
    text-decoration: underline;
  }
`;

export const Section = styled.button<IProps>`
${(p) => (p.isArabic ? "@media screen and (min-width: 881px){display:none}" : "@media screen and (min-width: 881px){display:none}")};
border: none;
float: ${(p) => (p.isArabic? "left" : "right" )};
width: 56px;
height: 42px;
background: url("/img/svg/mob_button.png") left top no-repeat;
&:active{
  opacity: 0.25;
}
`;
export const TopnavResponsive = styled.div<IProps>`
${(p) => (p.isArabic ? "@media screen and (min-width: 881px){display:none}" : "@media screen and (min-width: 881px){display:none}")};

display: block;
padding-top:10px;
ul{
  float: left;
  width: 100%;
  border-top: 2px solid #dcdcdc;
  background: #efeff0;
  padding: 0;
  margin: 0;
  position: relative;
  list-style: none;
  font-size: 100%;
    line-height: 1;
    font-family: Arial, Helvetica, sans-serif;
    text-align: left;
    vertical-align: baseline;
  li{
    display: table;
    float: left;
    width: 94%;
    font: normal 12px Arial;
    color: #514c4c;
    border-bottom: 2px solid #dcdcdc;
    padding: 2% 3%;
    margin: 0;
    list-style: none;
    text-align: ${(p) => (p.isArabic? "right" : "left" )};
    vertical-align: baseline;
    a{
      display: table-cell;
      float: none;
      width: 85%;
      text-decoration: none;
      font: bold 15px Arial;
      color: #de0000;
      margin: 0 0 5px;
      cursor: pointer;
      strong {
        font-weight: bold;
        font: bold 15px Arial;
    color: #de0000;
    }
    }
  }
}
`;

export const ImgSpan=styled("span")`
padding:20px;
`
